import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  numberContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: `0 ${theme.borderRadius.std}px ${theme.borderRadius.std}px 0`,
    backgroundColor: theme.colors.blueMuted,
    paddingLeft: theme.marginBase * 2,
    paddingRight: theme.marginBase,
    height: theme.marginBase * 4,
  },
  number: {
    textAlign: 'center',
    ...theme.fonts.label,
    color: theme.colors.blueAccessible,
  },
}));

interface Props {
  number: number;
}

export const FieldNumber = ({ number }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.numberContainer}>
      <span className={classes.number}>{number}</span>
    </div>
  );
};
